import React from "react";

const SectionList = ({ sections, selectedSection, onSectionSelect }) => {
  return (
    <div className="grid grid-cols-5 gap-2">
      {sections.map((section) => (
        <div
          key={section.sectionId}
          className={`pl-20 font-normal py-2 bg-transparent cursor-pointer ${
            selectedSection === section.sectionId
              ? "text-[#06513D]"
              : "text-black"
          }`}
          onClick={() => onSectionSelect(section.sectionId)}
        >
          {section.name}
        </div>
      ))}
    </div>
  );
};

export default SectionList;
